import { render } from "./CreateGroupPermissionPage.vue?vue&type=template&id=8699388c&ts=true"
import script from "./CreateGroupPermissionPage.vue?vue&type=script&lang=ts"
export * from "./CreateGroupPermissionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__